import {TypeAutorisationEnum} from "@resources/resources";

export class TypeAutorisationEnums {

  private static _public: TypeAutorisationEnum = 'PUBLIC';
  private static _correspondant: TypeAutorisationEnum = 'CORRESPONDANT';

  static PUBLIC = new TypeAutorisationEnums(TypeAutorisationEnums._public);
  static CORRESPONDANT = new TypeAutorisationEnums(TypeAutorisationEnums._correspondant);

  private static _values = [TypeAutorisationEnums.CORRESPONDANT.value(), TypeAutorisationEnums.PUBLIC.value()];

  constructor(public str: TypeAutorisationEnum) {
  }

  value(): TypeAutorisationEnum {
    return this.str;
  }

  static values(): Array<TypeAutorisationEnum> {
    return this._values;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-notifications/digicerba-notifications-web/src/angular/cerba/src/app/common/enum/typeautorisation.enum.ts